import { render } from "./BillDetailType.vue?vue&type=template&id=3f1d4272"
import script from "./scripts/bill-detail-type.ts?vue&type=script&language=ts&lang=js"
export * from "./scripts/bill-detail-type.ts?vue&type=script&language=ts&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__